// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var TicketGenerationLogic$ReactHooksTemplate = require("./TicketGenerationLogic.res.js");

var emptyState_survey = Survey$ReactHooksTemplate.empty();

var emptyState = {
  survey: emptyState_survey,
  ticketLogics: /* [] */0,
  deletedTicketLogics: /* [] */0,
  edited: false
};

function TicketGenerationPage(props) {
  var campaignId = props.campaignId;
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  var state = match[0];
  var fetchCampaign = function (survey) {
    var partial_arg = Survey$ReactHooksTemplate.ticketCategories(survey);
    var partial_arg$1 = Survey$ReactHooksTemplate.redirectionUrls(survey);
    var partial_arg$2 = Survey$ReactHooksTemplate.id(survey);
    var partial_arg$3 = Survey$ReactHooksTemplate.dataFields(survey);
    var partial_arg$4 = Survey$ReactHooksTemplate.thankYouList(survey);
    var partial_arg$5 = Survey$ReactHooksTemplate.welcome(survey);
    var partial_arg$6 = Survey$ReactHooksTemplate.questions(survey);
    var partial_arg$7 = function (param) {
      return Logic$ReactHooksTemplate.decode(partial_arg$6, partial_arg$5, partial_arg$4, partial_arg$3, partial_arg$2, partial_arg$1, partial_arg, param);
    };
    var partial_arg$8 = function (param) {
      return Json_decode.list(partial_arg$7, param);
    };
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaigns/" + campaignId + "/ticket_generation_logics", (function (param) {
                  return Json_decode.field("logics", partial_arg$8, param);
                }));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (surveyId) {
                  return Js_promise.then_((function (json) {
                                var survey = Json_decode.field("survey", Survey$ReactHooksTemplate.fromJson, json);
                                Curry._1(setState, (function (state) {
                                        return {
                                                survey: survey,
                                                ticketLogics: state.ticketLogics,
                                                deletedTicketLogics: state.deletedTicketLogics,
                                                edited: state.edited
                                              };
                                      }));
                                return Js_promise.then_((function (logics) {
                                              Curry._1(setState, (function (state) {
                                                      return {
                                                              survey: state.survey,
                                                              ticketLogics: logics,
                                                              deletedTicketLogics: state.deletedTicketLogics,
                                                              edited: state.edited
                                                            };
                                                    }));
                                              return Promise.resolve();
                                            }), fetchCampaign(survey));
                              }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/surveys/" + String(surveyId)));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaigns/" + campaignId, (function (param) {
                      return Json_decode.field("campaign", (function (param) {
                                    return Json_decode.field("survey_id", Json_decode.$$int, param);
                                  }), param);
                    })));
        }), []);
  var emptyTicketLogic = function (surveyId, priority, question, ticketCategories) {
    return Logic$ReactHooksTemplate.make({
                TAG: "Survey",
                _0: surveyId
              }, "TicketGeneration", {
                hd: LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                      TAG: "Question",
                      _0: question
                    }),
                tl: /* [] */0
              }, priority, {
                hd: Action$ReactHooksTemplate.emptyTicketGenerationAction(Belt_List.head(ticketCategories)),
                tl: /* [] */0
              });
  };
  var createTicketLogic = function (param) {
    var id = Survey$ReactHooksTemplate.id(state.survey);
    if (id === undefined) {
      return ;
    }
    var logicListCount = List.length(Belt_List.keep(state.ticketLogics, (function (x) {
                return Logic$ReactHooksTemplate.category(x) === "TicketGeneration";
              })));
    var newPriority = logicListCount + 1 | 0;
    var firstQuestion = List.hd(state.survey.questions);
    var logic = emptyTicketLogic(id, newPriority, firstQuestion, state.survey.ticketCategories);
    var updatedLogics = List.append(state.ticketLogics, {
          hd: logic,
          tl: /* [] */0
        });
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    ticketLogics: updatedLogics,
                    deletedTicketLogics: state.deletedTicketLogics,
                    edited: true
                  };
          }));
  };
  var updateTicketLogics = function (index, newLogic) {
    var updatedLogic = List.mapi((function (i, logic) {
            if (i === index) {
              return newLogic;
            } else {
              return logic;
            }
          }), state.ticketLogics);
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    ticketLogics: updatedLogic,
                    deletedTicketLogics: state.deletedTicketLogics,
                    edited: true
                  };
          }));
  };
  var removeTicketLogics = function (logic) {
    var updatedLogic = Belt_List.keep(state.ticketLogics, (function (x) {
            return Caml_obj.notequal(x, logic);
          }));
    var updatedDeletedLogics = Belt_List.add(state.deletedTicketLogics, logic);
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    ticketLogics: updatedLogic,
                    deletedTicketLogics: updatedDeletedLogics,
                    edited: true
                  };
          }));
  };
  var saveTicketLogics = function (param) {
    var logicsAttributes = Belt_List.toArray(Belt_List.concat(Belt_List.map(state.ticketLogics, (function (x) {
                    return Logic$ReactHooksTemplate.toJson(undefined, x);
                  })), Belt_List.map(state.deletedTicketLogics, (function (x) {
                    return Logic$ReactHooksTemplate.toJson(true, x);
                  }))));
    var params = Json_encode.object_({
          hd: [
            "campaign",
            Json_encode.object_({
                  hd: [
                    "logics_attributes",
                    logicsAttributes
                  ],
                  tl: /* [] */0
                })
          ],
          tl: /* [] */0
        });
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", Json_decode.string, response);
            if (status === "success") {
              Js_promise.then_((function (logics) {
                      Curry._1(setState, (function (state) {
                              return {
                                      survey: state.survey,
                                      ticketLogics: logics,
                                      deletedTicketLogics: /* [] */0,
                                      edited: false
                                    };
                            }));
                      return Promise.resolve();
                    }), fetchCampaign(state.survey));
            } else {
              console.log("Failed to save ticket logics");
            }
            return Promise.resolve();
          }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/campaigns/" + campaignId + "/ticket_generation_logics/bulk_update", params));
  };
  var match$1 = Survey$ReactHooksTemplate.id(state.survey);
  return JsxRuntime.jsx("div", {
              children: match$1 !== undefined ? JsxRuntime.jsx(TicketGenerationLogic$ReactHooksTemplate.make, {
                      survey: state.survey,
                      ticketLogics: state.ticketLogics,
                      updateTicketLogics: updateTicketLogics,
                      removeTicketLogics: removeTicketLogics,
                      createTicketLogic: createTicketLogic,
                      saveTicketLogics: saveTicketLogics,
                      edited: state.edited
                    }) : null,
              className: "p-10"
            });
}

var make = TicketGenerationPage;

exports.emptyState = emptyState;
exports.make = make;
/* emptyState Not a pure module */
